import {BaseConfig} from './services/base-config.service';
import { Component, OnInit } from '@angular/core';
import { AslibEnviromentService } from '@aslib/enviroment';
import { environment } from '../environments/environment';

@Component({
  selector: 'gpa-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  constructor(public aslibEnvironmentService: AslibEnviromentService) {}

  async ngOnInit() {
    await this.aslibEnvironmentService.config();

    this.aslibEnvironmentService.replace(environment);
    
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts